import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ToasterState {
  open: boolean;
  message: string;
  type: 'success' | 'error' | 'info';
  duration?: number; // in milliseconds
}

const initialState: ToasterState = {
  open: false,
  message: '',
  type: 'success',
  duration: 1500,
};

const toasterSlice = createSlice({
  name: 'toaster',
  initialState,
  reducers: {
    showToaster: (
      state,
      action: PayloadAction<{ message: string; type: 'success' | 'error' | 'info'; duration?: number }>,
    ) => {
      state.open = true;
      state.message = action.payload.message;
      state.type = action.payload.type;
      state.duration = action.payload.duration ?? 1500;
    },
    hideToaster: (state) => {
      state.open = false;
      state.duration = 1500;
    },
  },
});

export const { showToaster, hideToaster } = toasterSlice.actions;
export default toasterSlice.reducer;
